import React from 'react';
import { SurveyBase, SurveyContent } from './styled';
function Feedback() {
    return (React.createElement(SurveyBase, null,
        React.createElement(SurveyContent, { id: "footer-feedback-left" }),
        React.createElement(SurveyContent, { id: "footer-feedback-right" })));
}
export default Feedback;
